module.exports = __webpack_public_path__ + "img/平台1   手机.b52296e8.png";